import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DatePicker } from "antd";

dayjs.extend(customParseFormat);

// Dates are exchanged with the API as "YYYY-MM-DD".
const STORED_FORMAT = "YYYY-MM-DD";

const parseStored = (value) => {
	if (!value || typeof value !== "string") {
		return null;
	}
	const strict = dayjs(value, STORED_FORMAT, true);
	if (strict.isValid()) {
		return strict;
	}
	const loose = dayjs(value);
	return loose.isValid() ? loose : null;
};

/**
 * Date picker used across the app.
 *
 * This is the only file that knows which picker library is used, so swapping
 * the library later only means changing this component. `value` is a
 * "YYYY-MM-DD" string (or empty), and `onChange` receives a "YYYY-MM-DD"
 * string, or "" when cleared. It never passes half-typed text, so callers
 * don't need to guard against it.
 */
export default function DateField({ value, onChange, placeholder, disabled = false, allowClear = false, suffixIcon, style, className }) {
	const extra = {};
	if (suffixIcon !== undefined) {
		extra.suffixIcon = suffixIcon;
	}
	return (
		<DatePicker
			value={parseStored(value)}
			format={STORED_FORMAT}
			placeholder={placeholder}
			disabled={disabled}
			allowClear={allowClear}
			style={{ width: "100%", ...style }}
			className={className}
			onChange={(date) => onChange(date && date.isValid() ? date.format(STORED_FORMAT) : "")}
			{...extra}
		/>
	);
}

DateField.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	allowClear: PropTypes.bool,
	suffixIcon: PropTypes.node,
	style: PropTypes.object,
	className: PropTypes.string,
};
